// @ts-strict-ignore
import {Injectable, Injector} from "@angular/core";
import {SimSystemService} from "../../../../api/generated/service";
import {AudioClientMode, IAudioClientService} from "./i-audio-client.service";
import {GetClientPropertiesResponse, NetworkAudioInputChannel} from "@models";
import {BrowserAudioClientService} from "./browser-audio-client.service";
import {NetworkAudioClientService} from "./network-audio-client.service";
import {Observable} from "rxjs";
import {untilDestroyed} from "@ngneat/until-destroy";

export interface IAudioClientFactoryResponse {
	service: IAudioClientService;
	mode: AudioClientMode;
	channel: NetworkAudioInputChannel;
}

@Injectable()
export class AudioClientFactory {
	constructor(
		private _simSystemService: SimSystemService,
		private _injector: Injector,
	) {}

	async create(forMc?: boolean): Promise<IAudioClientFactoryResponse> {
		return this._simSystemService
			.getClientProperties()
			.then(async (data: GetClientPropertiesResponse) => {
				//Take any of the two mappings, if no specific is given
				//otherwise take the specific mapping
				let mapping = forMc === null ? (data?.recorder ?? data?.masterOfCeremony) : forMc ? data?.masterOfCeremony : data?.recorder;
				if (mapping?.simAudioNetworkTool) {
					return {
						service: this._injector.get(NetworkAudioClientService),
						mode: "network-audio-client",
						channel: null,
					};
				} else if (mapping?.vogNetworkAudioInputChannelIds?.length > 0) {
					return {
						service: this._injector.get(BrowserAudioClientService),
						mode: "browser",
						channel: mapping.vogNetworkAudioInputChannels[0],
					};
				} else {
					return null;
				}
			})
			.catch(() => null);
	}

	/*
	Create audio client and directly starts the send process
	@param forMc: If true, the audio client is created for the master of ceremony
	@param lifetime: The lifetime of the send process, if the lifetime object is destroyed the sending is automatically stopped
	 */
	async createAndSend(forMc: boolean, lifetime, startMuted = false): Promise<IAudioClientFactoryResponse> {
		const audioClient = await this.create(forMc);
		if (audioClient?.service) {
			audioClient?.service?.muted.set(startMuted);
			await audioClient.service.startSending(audioClient?.channel);
			if (lifetime) {
				new Observable()
					.pipe(untilDestroyed(lifetime))
					.subscribe()
					.add(() => audioClient.service.stopSending());
			}
		}
		return audioClient;
	}
}
